import React, { useState, useEffect } from "react";
import { Modal, Avatar, Table, Pagination, Popconfirm, Tag } from "antd";
import axiosInstance from "../../../api/Axios";
import CommonTopDetails from "../CommonTopDetails";
import { UserOutlined, InteractionTwoTone } from "@ant-design/icons";
const UserImpersonateModal = ({
  isUserImpersonateModalVisible,
  handleUserImpersonateModalClose,
  selectedRecord,
  selectedRecordDetails,
  impersonateUserAccount,
}) => {
  console.log(selectedRecord);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const [filterData, setFilterData] = useState({
    pageSize: 5,
    currentPage: 1,
    url: `/userorglist/`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, filter_url } = filterData;
  console.log(url);
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `${selectedRecord}/?page=${currentPage}&page_size=${pageSize}&search=${search}${filter_url}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `${selectedRecord}/?page=${currentPage}&page_size=${pageSize}${filter_url}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 150,
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 150,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.avatar || null}
            icon={!record?.avatar && <UserOutlined />}
            alt={record?.first_name}
            size="small"
          />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
    {
      title: "Roles",
      dataIndex: "roles",
      key: "roles",
      width: 200,
      render: (roles) => {
        let roleToDisplay = "User"; // Default role

        if (roles?.some((role) => role.key_name === "client_admin")) {
          roleToDisplay = "Admin";
        } else if (
          roles?.some((role) =>
            role.key_name.toLowerCase().includes("internal_trainer")
          )
        ) {
          roleToDisplay = "Internal Trainer";
        } else if (
          roles?.some((role) =>
            role.key_name.toLowerCase().includes("external_trainer")
          )
        ) {
          roleToDisplay = "External Trainer";
        } else if (
          roles?.some((role) => role.key_name.toLowerCase().includes("manager"))
        ) {
          roleToDisplay = "Manager";
        }

        return <Tag color="blue">{roleToDisplay}</Tag>;
      },
    },
    {
      title: "Actions",
      dataIndex: "id",
      key: "id",
      align: "center",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Popconfirm
            title={"Impersonate User"}
            description=" "
            onConfirm={() =>
              impersonateUserAccount(
                record?.user_id,
                selectedRecordDetails?.client_id
              )
            }
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
            placement="leftTop"
          >
            <InteractionTwoTone
              style={{
                cursor: "pointer",
                fontSize: "2rem",
                marginRight: "0.9rem",
              }}
              title="Impersonate"
            />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    if (selectedRecord) {
      LoadUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, selectedRecord]);

  return (
    <Modal
      title="Select a User for Impersonation"
      open={isUserImpersonateModalVisible}
      onCancel={handleUserImpersonateModalClose}
      footer={null}
      onClose={handleUserImpersonateModalClose}
      width={1000}
      //   centered
    >
      <CommonTopDetails
        title={`${selectedRecordDetails?.client_id} Users`}
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={false}
        marginPass="15px"
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        bordered
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </Modal>
  );
};

export default UserImpersonateModal;
